/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { decodeSpecialCharacters } from '../../utils';
const { APP_ENV } = process.env;

const ProductReviewProcess = ({
    articleType,
    isMobile,
    isAffiliate,
    disclaimer,
}) => {
    return (
        <div className="affiliate-text-wrapper">
            <p className="affiliate-text" dangerouslySetInnerHTML={ { __html: decodeSpecialCharacters(disclaimer) } }></p>
        </div>
    );
};

ProductReviewProcess.propTypes = {
    articleType: PropTypes.string,
    isMobile: PropTypes.boolean,
    isAffiliate: PropTypes.boolean,
};

export default ProductReviewProcess;
